
import { useScrollAnimation, getAnimationClass } from '../../../hooks/useScrollAnimation';

function AnimatedSection({ children, animation = 'slide-up' as 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-in', className = '' }: { children: React.ReactNode; animation?: 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-in'; className?: string }) {
  const { ref, isVisible } = useScrollAnimation();
  return (
    <div ref={ref} className={`${getAnimationClass(isVisible, animation)} ${className}`}>
      {children}
    </div>
  );
}

export default function TrustBadges() {
  const badges = [
    { icon: 'ri-shield-check-line', label: 'HIPAA Compliant', sub: 'Seguridad certificada', color: 'bg-emerald-500' },
    { icon: 'ri-star-fill', label: '4.9 Estrellas', sub: 'Valoración usuarios', color: 'bg-amber-500' },
    { icon: 'ri-trophy-line', label: 'Top SaaS 2025', sub: 'Salud Visual', color: 'bg-rose-500' },
    { icon: 'ri-lock-line', label: 'Encriptación AES-256', sub: 'Datos protegidos', color: 'bg-gray-800' },
  ];

  return (
    <section className="py-14 bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <AnimatedSection animation="fade-in">
          <p className="text-center text-xs font-semibold text-gray-400 uppercase tracking-widest mb-10">
            Confianza y seguridad para tu práctica oftalmológica
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {badges.map((badge, index) => (
              <div key={index} className="flex items-center justify-center space-x-3 group cursor-pointer">
                <div className={`w-10 h-10 ${badge.color} rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform`}>
                  <i className={`${badge.icon} text-white text-lg`}></i>
                </div>
                <div>
                  <p className="text-xs font-bold text-gray-900">{badge.label}</p>
                  <p className="text-[11px] text-gray-500">{badge.sub}</p>
                </div>
              </div>
            ))}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
